import React, { useEffect, useRef } from 'react';
import pattulsavam1 from '../assets/kavuotherimg/pattulsavam1.webp';
import pattulsavam2 from '../assets/kavuotherimg/pattulsavam2.webp';
import pattulsavam3 from '../assets/kavuotherimg/pattulsavam3.webp';
import pattulsavam4 from '../assets/kavuotherimg/pattulsavam4.webp';
import pattulsavam5 from '../assets/kavuotherimg/pattulsavam5.webp';
import poorolsavam1 from '../assets/kavuotherimg/poorolsavam1.webp';
import poorolsavam2 from '../assets/kavuotherimg/poorolsavam2.webp';
import poorolsavam3 from '../assets/kavuotherimg/poorolsavam3.webp';
import poorolsavam4 from '../assets/kavuotherimg/poorolsavam4.webp';
import poorolsavam5 from '../assets/kavuotherimg/poorolsavam5.webp';
/**
 * A custom React hook that uses the Intersection Observer API
 * to detect when an element enters the viewport. It applies a
 * 'is-visible' class to trigger animations.
 *
 * @param {object} options - Configuration options for the IntersectionObserver.
 * @returns {React.RefObject} A ref object to be attached to the container element.
 */
const useIntersectionObserver = (options) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target); // Stop observing after animation
                }
            });
        }, options);

        const currentRef = containerRef.current;
        if (currentRef) {
            // Select all image blocks within the container to observe
            const elements = currentRef.querySelectorAll('.image-block');
            elements.forEach(el => observer.observe(el));
        }

        // Cleanup function to unobserve elements when the component unmounts
        return () => {
            if (currentRef) {
                const elements = currentRef.querySelectorAll('.image-block');
                elements.forEach(el => observer.unobserve(el));
            }
        };
    }, [options]);

    return containerRef;
};

/**
 * The Festivals component displays information about Paattulsavam and Poorotsavam
 * using an animated grid layout.
 *
 * @param {object} props - The component's properties.
 * @param {function} props.openImageViewer - A function to open the fullscreen image viewer.
 */
const Festivals = ({ openImageViewer }) => {
    // Create separate refs for each grid to observe them independently
    const paattulsavamGridRef = useIntersectionObserver({ threshold: 0.2 });
    const poorotsavamGridRef = useIntersectionObserver({ threshold: 0.2 });

    /**
     * Handles clicks on the image grid, finds the clicked image's source,
     * and calls the openImageViewer function.
     * @param {React.MouseEvent} e - The mouse event.
     */
    const handleImageClick = (e) => {
        // Find the closest parent with the 'clickable-image' class to get the image source
        const imgSrc = e.target.closest('.clickable-image')?.querySelector('img')?.src;
        if (imgSrc) {
            openImageViewer(imgSrc);
        }
    };

    return (
        <>
            {/* Paattulsavam Section */}
            <div className="page" id="page5b">
                <h2 className="content-title">പാട്ടുത്സവം</h2>
                <div className="festival-grid" ref={paattulsavamGridRef} onClick={handleImageClick}>
                    <div className="festival-item text-block grid-col-span-2">
                        <p>ഉത്തരകേരളത്തിലെ ദേവി ക്ഷേത്രങ്ങളിലെ ഉത്സവമാണിത് വൃശ്ചിക മാസത്തിലെ കാർത്തിക നാൾ തൊട്ട് ആയില്യം നാൾ വരെയുള്ള ഏഴു ദിവസങ്ങളിൽ ആണ് പാട്ടുത്സവം കൊണ്ടാടുന്നത് നല്ല ദിവസം നോക്കി ജ്യോതിഷനെ വരുത്തി പ്രശ്ന ചിന്തയിലൂടെ മുഹൂർത്തം കണ്ട് തെങ്ങിന്റെ ഓലകൊത്തൽ ചടങ്ങോട് കൂടിയാണ് പാട്ട് ഉത്സവം ആരംഭിക്കുന്നത് .</p>
                    </div>
                    <div className="festival-item image-block clickable-image grid-row-span-2">
                        <img src={pattulsavam1} alt="" className="festival-image" />
                    </div>
                    <div className="festival-item image-block clickable-image">
                        <img src={pattulsavam2} alt="" className="festival-image" />
                    </div>
                    <div className="festival-item image-block clickable-image grid-col-span-2">
                        <img src={pattulsavam4} alt=" " className="festival-image" />
                    </div>
                    <div className="festival-item image-block clickable-image">
                        <img src={pattulsavam3} alt="" className="festival-image" />
                    </div>
                    <div className="festival-item text-block grid-col-span-2">
                        <p>കാവിലെ വാല്യക്കാരുടെ ഭവനത്തിൽ നിന്നും ഓല കൊത്തി മടഞ്ഞ് പാട്ടിനു മുമ്പായി ക്ഷേത്രത്തിൽ എത്തിക്കണം. ഇത് ഉപയോഗിച്ചാണ് കാവിലെ പന്തൽ പണിയുന്നത് നാലാം പാട്ട് ദിവസം ആകുമ്പോഴേക്കും പന്തൽ പണി പൂർത്തിയായിരിക്കണം നാലാം പാട്ട് ദിവസവും അഞ്ചാം പാട്ട് ദിവസവുംവാല്യക്കാർക്കും അവകാശികൾക്കും അരി നൽകുന്ന ചടങ്ങുണ്ട് ഏഴാം പാട്ട് ദിവസത്തിലാണ് കാവിലെ പ്രധാനപ്പെട്ട ചടങ്ങായ തേങ്ങേറും കളത്തിൽ കളത്തിൽ അരി ചടങ്ങോട് കൂടി പാട്ടു ഉത്സവം സമാപിക്കുന്നു.</p>
                    </div>
                    <div className="festival-item image-block clickable-image">
                        <img src={pattulsavam5} alt="" className="festival-image" />
                    </div>
                </div>
            </div>

            {/* Poorotsavam Section */}
            <div className="page" id="page5">
                <h2 className="content-title">പൂരോത്സവം</h2>
                <div className="festival-grid" ref={poorotsavamGridRef} onClick={handleImageClick}>
                    <div className="festival-item image-block clickable-image grid-col-span-2">
                        <img src={poorolsavam2} alt=" " className="festival-image" />
                    </div>
                    <div className="festival-item text-block grid-col-span-2">
                        <p> കേരളത്തിലെ പ്രാചീന ഉത്സവങ്ങളിൽ പ്രധാനമാണ് പൂരോത്സവം മീനമാസത്തിലെ കാർത്തിക നാൾ മുതൽ പൂരം നാൾ വരെയുള്ള 9 ദിവസങ്ങളിലാണ് പൂരോത്സവം നടത്തിവരുന്നത് പൂര നക്ഷത്രം മീനമാസം ആദ്യ ദിവസങ്ങളിലാണ്  വരുന്നതെങ്കിൽ കുംഭ മാസത്തിലെ കാർത്തിക നാളിലാണ് ഉത്സവം ആരംഭിക്കുന്നത് കാമദേവ പൂജയാണ് പൂരവൃതത്തിന്റെ മുഖ്യചടങ്ങ്. ബാലികമാർ വ്രതം നോറ്റ് പൂര കുഞ്ഞുങ്ങളായി പൂരോത്സവം തുടങ്ങുന്നതിന് 16 ദിവസം മുന്നേ ക്ഷേത്രത്തിൽ എത്തിച്ചേരുകയാണ് പതിവ്. ചെക്കിപ്പൂവാണ് പൂവിടാൻ ഉപയോഗിക്കുന്നത് സന്ധ്യക്ക് വിളക്ക് വച്ചശേഷം പൂവിന് വെള്ളം കൊടുക്കുന്ന ചടങ്ങും ഉണ്ട്. എല്ലാ ദിവസവും പൂരക്കളിയും ഉണ്ടാകും. </p>
                    </div>
                    <div className="festival-item image-block clickable-image grid-row-span-2">
                        <img src={poorolsavam3} alt=" " className="festival-image" />
                    </div>
                     <div className="festival-item text-block grid-col-span-2">
                        <p>ക്ഷേത്ര സമുദായിക്കാരും കൂട്ടായി കാരും ചേർന്ന് പൂരക്കളി പണിക്കരെ കളിക്ക് ക്ഷണിച്ച് ഏൽപ്പിക്കുന്ന തോടെയാണ് പൂരക്കളിയുടെ ചടങ്ങ് ആരംഭിക്കുന്നത്. ഉത്സവത്തിന്റെ അവസാന നാളുകളിൽ പൂരത്തിന്റെ തലേദിവസം തെക്കരും കുറിഞ്ഞി വടക്കരും തമ്മിൽ തലയന്നേരി കാവിൽ വച്ച് ഇരു കാവിലെയും പണിക്കർ മാർ തമ്മിൽ മറത്തുകളി അരങ്ങേറും. പൂരം നാളിൽ തെക്കരും വടക്കരും യോജിച്ച് പൂരക്കളി കളിച്ച് പള്ളിയറയിലെ വിഗ്രഹത്തെ ക്ഷേത്രക്കുളത്തിൽ വച്ച് കുളിപ്പിക്കുന്ന ചടങ്ങാണ് പൂരംകുളി.</p>
                    </div>
                    <div className="festival-item image-block clickable-image">
                        <img src={poorolsavam5} alt="" className="festival-image" />
                    </div>
                   
                    <div className="festival-item image-block clickable-image">
                        <img src={poorolsavam1} alt="" className="festival-image" />
                    </div>
                    
                    <div className="festival-item image-block clickable-image grid-col-span-2">
                        <img src={poorolsavam4} alt="" className="festival-image" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Festivals;